(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-hero"] && !Shopify.designMode) return;
  try {
    
  class APHeroMedia extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.mediaQuery = window.matchMedia('(max-width: 749px)');

      if (!this.hasAttribute('data-media-presentation-initialized')) {
        const activeViewport = this.mediaQuery.matches ? 'mobile' : 'desktop';

        this.initializePresentation('desktop', activeViewport === 'desktop');
        this.initializePresentation('mobile', activeViewport === 'mobile');
        this.setAttribute('data-media-presentation-initialized', '');
      }

      this.syncViewport = () => {
        const viewport = this.mediaQuery.matches ? 'mobile' : 'desktop';

        if (!this.hasAttribute(`data-${viewport}-presentation-cycled`)) {
          this.initializePresentation(viewport, true);
        }

        this.syncVideoPlayback(viewport);
      };

      this.mediaQuery.addEventListener('change', this.syncViewport, {
        signal: this.abortController.signal,
      });
      this.syncViewport();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    initializePresentation(viewport, shouldCycle) {
      const layout = this.dataset[`${viewport}Layout`];
      const activeClass = `is-active-${viewport}`;
      const items = Array.from(this.querySelectorAll('.hero__media-item')).filter(
        (item) => item.dataset[`${viewport}Media`] === 'true'
      );

      if (layout !== 'alternate' || items.length === 0) {
        this.setAttribute(`data-${viewport}-presentation-cycled`, '');
        return;
      }

      let next = 0;

      if (shouldCycle && items.length > 1) {
        const key = `apHeroMediaIndex_${this.dataset.sectionId}_${viewport}`;

        try {
          const last = Number.parseInt(window.localStorage.getItem(key), 10);

          if (!Number.isNaN(last)) {
            next = (last + 1) % items.length;
          }

          window.localStorage.setItem(key, next);
        } catch (error) {
          next = 0;
        }
      }

      this.querySelectorAll(`.${activeClass}`).forEach((item) => item.classList.remove(activeClass));
      items[next].classList.add(activeClass);

      if (shouldCycle) {
        this.prioritize(items[next]);
        this.setAttribute(`data-${viewport}-presentation-cycled`, '');
      }
    }

    prioritize(item) {
      if (this.dataset.priority !== 'high') return;

      const image = item.querySelector('img');
      if (!image) return;

      image.loading = 'eager';
      image.fetchPriority = 'high';
    }

    syncVideoPlayback(viewport) {
      const layout = this.dataset[`${viewport}Layout`];
      const activeClass = `is-active-${viewport}`;

      this.querySelectorAll('.hero__media-item').forEach((item) => {
        const itemIsVisible =
          item.dataset[`${viewport}Media`] === 'true' &&
          (layout !== 'alternate' || item.classList.contains(activeClass));

        item.querySelectorAll('video').forEach((video) => {
          const wrapper = video.closest('.hero__media-wrapper');
          const videoIsVisible = wrapper?.classList.contains(`hero__media-wrapper--${viewport}`);

          if (itemIsVisible && videoIsVisible) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }
  }

  if (!customElements.get('ap-hero-media')) {
    customElements.define('ap-hero-media', APHeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-fabrication"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
